import { queryOptions } from '@tanstack/react-query';
import fetchClient from '@eureca/recruiter-api-sdk/client';
import type { GetJobsId200 } from '@eureca/recruiter-api-sdk/types';

export type JobDetail = GetJobsId200;

export class JobFetchError extends Error {
  readonly name = 'JobFetchError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

export function jobByIdQueryKey(jobId: string) {
  return ['recruiter', 'jobs', 'by-id', jobId] as const;
}

async function fetchJobById(jobId: string, signal?: AbortSignal): Promise<JobDetail> {
  const res = await fetchClient<JobDetail>({
    method: 'GET',
    url: `/jobs/${jobId}`,
    signal,
  });
  if (res.error) {
    throw new JobFetchError(`Failed to load job (status ${res.error.status})`, res.error.status);
  }
  return res.data;
}

export function jobByIdQueryOptions(jobId: string) {
  return queryOptions({
    queryKey: jobByIdQueryKey(jobId),
    queryFn: ({ signal }) => fetchJobById(jobId, signal),
    staleTime: 60_000,
    retry: (failureCount, err) => {
      if (err instanceof JobFetchError && err.status >= 400 && err.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
